module.exports = __webpack_public_path__ + "img/emoji_37.7c701b03.png";